
import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import ImageComponent from './ImageComponent';

export const CustomImage = Node.create({
  name: 'customImage',
  
  group: 'block',
  
  content: '',
  
  marks: '',
  
  selectable: true,
  
  draggable: true,
  
  atom: true,

  addAttributes() {
    return {
      src: {
        default: null,
      },
      alt: {
        default: 'Image',
      },
      title: {
        default: null,
      },
      width: {
        default: '100%',
      },
      alignment: {
        default: 'center',
      },
      caption: {
        default: '',
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'figure[data-type="custom-image"]',
        getAttrs: (node) => {
          const figure = node as HTMLElement;
          const img = figure.querySelector('img');
          const figcaption = figure.querySelector('figcaption');
          
          return {
            src: img?.getAttribute('src') || '',
            alt: img?.getAttribute('alt') || 'Image',
            title: img?.getAttribute('title') || null,
            width: figure.style.width || '100%',
            alignment: figure.getAttribute('data-alignment') || 'center',
            caption: figcaption?.textContent || '',
          };
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const { src, alt, title, width, alignment, caption, ...rest } = HTMLAttributes;
    
    // Set figure style based on alignment and width
    const style = `width: ${width};`;
    
    return [
      'figure',
      mergeAttributes({ 
        'data-type': 'custom-image',
        'data-alignment': alignment,
        style
      }, rest),
      ['img', { src, alt, title }],
      caption ? ['figcaption', caption] : '',
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(ImageComponent);
  },
});
